import React from 'react';
import mainImg from '../../assets/img/aboutus/1.png';
import award1 from '../../assets/img/aboutus/2.png';
import award2 from '../../assets/img/aboutus/3.png';
import award3 from '../../assets/img/aboutus/4.png';

const Aboutus5 = () => {
    return (
        <section className="aboutus5-section">
            <div className="aboutus5-container">
                <div className="aboutus5-left">
                    <img src={mainImg.src || mainImg} alt="Excellence in AEC" className="aboutus5-main-img" />
                </div>
                
                <div className="aboutus5-right">
                    <h2 className="title">
                        Delivering Excellence in <span className="text-secondary">Architecture, Engineering & Construction (AEC)</span>
                    </h2>
                    <p className="desc">
                        No matter the project size, Scan to BIM Service Company has the expertise to 
                        provide optimal solutions, execute them safely, and ensure a successful outcome.
                    </p>

                    <div className="aboutus5-mission-vision">
                        <div className="mv-box">
                            <h3 className="subtitle">•Our Mission</h3>
                            <p className="desc">
                                To consistently deliver superior and efficient service for the shared 
                                benefit of our clients, shareholders, and employees.
                            </p>
                        </div>
                        <div className="mv-box">
                            <h3 className="subtitle">•Our Vision</h3>
                            <p className="desc">
                                To be a leading international architecture and BIM modeling firm 
                                known for our great people, service, and results.
                            </p>
                        </div>
                    </div>

                    <div className="aboutus5-awards-section">
                        <h3 className="subtitle">•Our Awards</h3>
                        <div className="awards-grid">
                            <div className="award-item">
                                <img src={award1.src || award1} alt="Award 2025" />
                                <div className="award-info">
                                    <span className="award-year">2025</span>
                                    <p className="award-name">Architectural Excellence Award</p>
                                </div>
                            </div>
                            <div className="award-item">
                                <img src={award2.src || award2} alt="Award 2019" />
                                <div className="award-info">
                                    <span className="award-year">2019</span>
                                    <p className="award-name">India 500 Startup Awards</p>
                                </div>
                            </div>
                            <div className="award-item">
                                <img src={award3.src || award3} alt="Award 2018" />
                                <div className="award-info">
                                    <span className="award-year">2018</span>
                                    <p className="award-name">Top Engineering & Architecture Company</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Aboutus5;
